import React from "react"
import PropTypes from "prop-types"
import ThingTemplate from "../components/pagetemplates/ThingTemplate"
import Layout from "../components/Layout"
import Seo from "../components/Seo"

/********************************
game.jsx
/********************************
Version: 1
Created: 01 10 2023
Updated: 01 10 2023
Author: Richy Pears
/********************************
Template file, used by gatsby-node.

The actual layout is abstracted to 
a relevant file in "pagetemplates"
to assist with decoupling 
presentation with function.
/********************************/

const Thing = props => {
  const { pageContext, location } = props

  const doc = JSON.parse(pageContext?.story?.content);

  // console.log("%c📹 Case Study Template MOUNTED", "color:#0f0; font-size:14px;")

  return (
    <Layout editor={false}>

        <ThingTemplate data={doc && doc} location={location} />
        
    </Layout>
  )

}

export default Thing

export const Head = ({ pageContext }) => {
  const doc = JSON.parse(pageContext?.story?.content);
  return <Seo seo={doc.seo} title={doc.seo?.title || doc.title || null} description={doc.seo?.description || doc.description || null} image={doc?.seo_image || doc?.image || null} />
}

Thing.defaultProps = {
  data: null,
  pageContext: null,
}

Thing.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
}

